import { AlpineComponent } from "alpinejs";

const Footer = (): AlpineComponent => ({

  selectLanguage(event: any) {
    event.preventDefault();

    const language = event.target.value;
    window.location.href = language;
  }

});

export default Footer;